exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".test .v-menu__content{max-height:90%!important}", ""]);

// exports
